import { RefiBanner } from './banner.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../lit-element.js';
import '../../styles/reset.style.js';
import '../../styles/links.style.js';
import './utils/constants.js';

defineRefiElement('refi-common-banner', RefiBanner);
